import { render, staticRenderFns } from "./ShowDocuments.vue?vue&type=template&id=a4b38cce&scoped=true"
import script from "./ShowDocuments.vue?vue&type=script&lang=js"
export * from "./ShowDocuments.vue?vue&type=script&lang=js"
import style0 from "./ShowDocuments.vue?vue&type=style&index=0&id=a4b38cce&prod&lang=css"
import style1 from "./ShowDocuments.vue?vue&type=style&index=1&id=a4b38cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b38cce",
  null
  
)

export default component.exports